import type { Partner } from "@expert/shared-types";
import type { JSX } from "react";

import { SaleProgress } from "../../../../../types";
import { ATTIcon } from "./icons/ATTIcon";
import { OptimumIcon } from "./icons/OptimumIcon";
import { VerizonIcon } from "./icons/VerizonIcon";
import classes from "./PlanCard.module.css";

export function determineCardStyle(saleProgress: SaleProgress | undefined) {
    if (saleProgress === SaleProgress.Success) {
        return classes.enrolled;
    } else if (saleProgress === SaleProgress.Declined) {
        return classes.declined;
    }
}

export function getPartnerIcon(partner: string): JSX.Element | null {
    switch (partner) {
        case "verizon":
        case "fios":
            return <VerizonIcon />;
        case "att":
            return <ATTIcon />;
        case "optimum":
            return <OptimumIcon />;
        default:
            return null;
    }
}

export function showRecommended(_partner: Partner, _productSku: string, _sessionId: string): boolean {
    return true;
}
